import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {ProductQueryParams, RegistrationSummary} from '../../../models';
import {Bundle, Catalog, PagedApiResponse, Product} from '../../../models/clare';

export const CatalogDetailActions = createActionGroup({
  source: 'Catalog Detail',
  events: {
    Load: props<{catalogId: string}>(),
    'Load Success': props<{catalog: Catalog}>(),
    'Load Failure': props<{error: ProductManagementErrorInterface}>(),
    'Load Registrations': emptyProps(),
    'Load Registrations Success': props<{registrations: RegistrationSummary[]}>(),
    'Load Registrations Failure': props<{error: ProductManagementErrorInterface}>(),
    'Load Products': emptyProps(),
    'Products Query Changed': props<{queryParams: ProductQueryParams}>(),
    'Load Products Success': props<{products: PagedApiResponse<Product>}>(),
    'Load Products Failure': props<{error: ProductManagementErrorInterface}>(),
    'Product Selection Changed': props<{currentPageProductIds: string[]; selectedProductIds: string[]}>(),
    'Remove Products': props<{productIds: number[]}>(),
    'Remove Products Success': props<{productIds: number[]}>(),
    'Remove Products Failure': props<{error: ProductManagementErrorInterface}>(),
    'Ensure Bundles Loaded': emptyProps(),
    'Load Bundles': emptyProps(),
    'Bundles Query Changed': props<{queryParams: ProductQueryParams}>(),
    'Load Bundles Success': props<{bundles: PagedApiResponse<Bundle>}>(),
    'Load Bundles Failure': props<{error: ProductManagementErrorInterface}>(),
    'Bundle Selection Changed': props<{currentPageBundleIds: string[]; selectedBundleIds: string[]}>(),
    'Remove Bundles': props<{bundleIds: number[]}>(),
    'Remove Bundles Success': props<{bundleIds: number[]}>(),
    'Remove Bundles Failure': props<{error: ProductManagementErrorInterface}>(),
    'Open Product Chooser': emptyProps(),
    'Close Product Chooser': emptyProps(),
    'Load Product Choices': emptyProps(),
    'Product Choices Query Changed': props<{queryParams: ProductQueryParams}>(),
    'Load Product Choices Success': props<{products: PagedApiResponse<Product>}>(),
    'Load Product Choices Failure': props<{error: ProductManagementErrorInterface}>(),
    'Product Choices Selection Changed': props<{currentPageProductIds: string[]; selectedProductIds: string[]}>(),
    'Add Selected Products': emptyProps(),
    'Add Selected Products Success': emptyProps(),
    'Add Selected Products Failure': props<{error: ProductManagementErrorInterface}>(),
    'Open Bundle Chooser': emptyProps(),
    'Close Bundle Chooser': emptyProps(),
    'Load Bundle Choices': emptyProps(),
    'Bundle Choices Query Changed': props<{queryParams: ProductQueryParams}>(),
    'Load Bundle Choices Success': props<{bundles: PagedApiResponse<Bundle>}>(),
    'Load Bundle Choices Failure': props<{error: ProductManagementErrorInterface}>(),
    'Bundle Choices Selection Changed': props<{currentPageBundleIds: string[]; selectedBundleIds: string[]}>(),
    'Add Selected Bundles': emptyProps(),
    'Add Selected Bundles Success': emptyProps(),
    'Add Selected Bundles Failure': props<{error: ProductManagementErrorInterface}>(),
    Update: props<{catalog: Catalog}>(),
    'Update Success': props<{catalog: Catalog}>(),
    'Update Failure': props<{error: ProductManagementErrorInterface}>(),
    'Reset Update Status': emptyProps(),
  },
});
